<template>
	<mdb-modal v-if="hasErrors" :show="showErrorPopup" @close="HIDE_ERROR_POPUP" class="text-black-50" position="top" size="sm" color="danger">
		<mdb-modal-header>
			<mdb-modal-title>Что-то пошло не так</mdb-modal-title>
		</mdb-modal-header>
		<mdb-modal-body>
			<error v-for="(error, index) in errors" :key="index" v-bind="error" @delete="FLUSH_ERROR(index)"/>
		</mdb-modal-body>
	</mdb-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { mdbBtn, mdbModal, mdbModalTitle, mdbModalHeader, mdbModalBody, mdbModalFooter } from '@/components/mdbvue'
import { mapRootMutations, mapRootState } from '@/store'

import Error from './Error.vue'

export default defineComponent({
	name: 'Errors',
	components: { mdbBtn, mdbModal, mdbModalTitle, mdbModalHeader, mdbModalBody, mdbModalFooter, Error },
	computed: {
		hasErrors () {
			return this.errors.length > 0
		},
		...mapRootState(['errors', 'showErrorPopup'])
	},
	methods: {
		...mapRootMutations(['FLUSH_ERROR', 'HIDE_ERROR_POPUP'])
	}
})
</script>

<style scoped>

</style>
